import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, StarIcon } from 'lucide-react';
interface CategoriesModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CategoriesModal({
  isOpen,
  onClose
}: CategoriesModalProps) {
  const tiers = [{
    stars: 1,
    name: '1 Estrella',
    followers: '5,000 - 9,999',
    platform: 'Seguidores en Instagram o TikTok',
    description: 'Categoría inicial para creadores emergentes. Accede a beneficios básicos en comercios afiliados y comienza a disfrutar de descuentos exclusivos.'
  }, {
    stars: 2,
    name: '2 Estrellas',
    followers: '10,000 - 99,999',
    platform: 'Seguidores en Instagram o TikTok',
    description: 'Nivel intermedio con beneficios mejorados. Disfruta de descuentos más significativos y acceso a promociones especiales en nuestra red de aliados.'
  }, {
    stars: 3,
    name: '3 Estrellas',
    followers: '100,000 - 999,999',
    platform: 'Seguidores en Instagram o TikTok',
    description: 'Categoría avanzada para creadores establecidos. Accede a beneficios premium, invitaciones a eventos exclusivos y servicios preferenciales.'
  }, {
    stars: 4,
    name: '4 Estrellas',
    followers: '1,000,000+',
    platform: 'Seguidores en Instagram o TikTok',
    description: 'Nivel elite para creadores top. Disfruta de los mejores beneficios, acceso VIP, experiencias únicas y el máximo nivel de atención en todos los comercios afiliados.'
  }];
  return <AnimatePresence data-id="element-107">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" data-id="element-108" />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-109">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-[#0a0a0a] border border-white/10 rounded-2xl max-w-4xl w-full max-h-[85vh] overflow-hidden pointer-events-auto shadow-2xl" data-id="element-110">
              <div className="sticky top-0 bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/10 px-6 py-4 flex items-center justify-between" data-id="element-111">
                <h2 className="text-2xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-112">
                  Categorías Elite Creator Pass
                </h2>
                <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 transition-colors" data-id="element-113">
                  <XIcon className="w-5 h-5 text-gray-400" data-id="element-114" />
                </button>
              </div>

              <div className="px-6 py-8 overflow-y-auto max-h-[calc(85vh-80px)]" data-id="element-115">
                <p className="text-gray-400 mb-8 text-center max-w-2xl mx-auto" data-id="element-116">
                  Tu categoría se determina automáticamente según tu número de
                  seguidores en Instagram o TikTok. Los beneficios específicos
                  de cada categoría son definidos por cada comercio afiliado.
                </p>

                <div className="space-y-6" data-id="element-117">
                  {tiers.map((tier, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.4,
                delay: index * 0.1
              }} className="bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:border-[#d4af37]/50 transition-all duration-300" data-id="element-118">
                      <div className="flex items-start gap-6" data-id="element-119">
                        <div className="flex-shrink-0" data-id="element-120">
                          <div className="w-20 h-20 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-xl flex items-center justify-center" data-id="element-121">
                            <div className="flex flex-col items-center" data-id="element-122">
                              <div className="flex gap-0.5 mb-1" data-id="element-123">
                                {[...Array(tier.stars)].map((_, i) => <StarIcon key={i} className="w-3 h-3 text-black fill-black" data-id="element-124" />)}
                              </div>
                              <span className="text-xs font-bold text-black" data-id="element-125">
                                {tier.name}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="flex-1" data-id="element-126">
                          <h3 className="text-xl font-bold text-white mb-2" data-id="element-127">
                            {tier.name}
                          </h3>
                          <div className="flex items-baseline gap-2 mb-3" data-id="element-128">
                            <span className="text-2xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-129">
                              {tier.followers}
                            </span>
                            <span className="text-sm text-gray-500" data-id="element-130">
                              {tier.platform}
                            </span>
                          </div>
                          <p className="text-gray-400 leading-relaxed" data-id="element-131">
                            {tier.description}
                          </p>
                        </div>
                      </div>
                    </motion.div>)}
                </div>

                <div className="mt-8 p-4 bg-white/5 border border-white/10 rounded-xl" data-id="element-132">
                  <p className="text-sm text-gray-400 text-center" data-id="element-133">
                    <strong className="text-white" data-id="element-134">Nota:</strong> Tu categoría
                    se actualiza automáticamente conforme crece tu audiencia.
                    Los beneficios específicos varían según cada comercio
                    afiliado y pueden incluir descuentos, promociones
                    especiales, servicios preferenciales, invitaciones a eventos
                    y más.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}